import { schema } from 'normalizr';

const sharepointSiteSchema = new schema.Entity('sharepointSites', {});

export default sharepointSiteSchema;
